export default "query evasioneRichiesta ($params: EvasioneRichiestaParams!) {\n    evasioneRichiesta(params: $params)\n}";